import InstructionStatisticsPage from "@/pages/common/InstructionStatisticsPage";

const ApproverStatistics: React.FC = () => <InstructionStatisticsPage role='approver' />;

export default ApproverStatistics;
